export const dienstenItems = [
  {
    title: "Ramen reparatie en vervangen",
    desc: "Raam kapot, klemt of sluit niet meer? Wij repareren en vervangen alle ramen in Eindhoven. Vanaf €75, 48u-spoedservice, alle merken.",
    price: "Vanaf €75",
    link: "/ramen-reparatie/",
    linkText: "Meer →",
  },
  {
    title: "Kozijnreparatie PVC, aluminium en hout",
    desc: "Defect sluitmechanisme, versleten beslag, klemmend raam of tocht? Wij herstellen vakkundig, vaak in 1 bezoek.",
    price: "Vanaf €85",
    link: "/kozijn-reparatie/",
    linkText: "Meer →",
  },
  {
    title: "Schuifpui reparatie",
    desc: "Loopt uw schuifpui stroef of hangt scheef? Wij vervangen rollers, herstellen rails en stellen mechanisme bij. Alle merken.",
    price: "Vanaf €95",
    link: "/schuifpui-reparatie/",
    linkText: "Meer →",
  },
  {
    title: "Draaikiepraam afstellen",
    desc: "Sluit uw draaikiepraam niet meer goed? Wij stellen alle merken af: Roto, Winkhaus, Maco, Sobinco. 30-45 min per raam.",
    price: "Vanaf €75",
    link: "/draaikiepraam-reparatie/",
    linkText: "Meer →",
  },
  {
    title: "Glas vervangen en HR++",
    desc: "Gebroken ruit of upgrade naar HR++ isolatieglas? Wij meten, leveren en plaatsen op maat. Advies subsidies inbegrepen.",
    price: "Op offerte",
    link: "/glas-vervangen/",
    linkText: "Meer →",
  },
  {
    title: "Slot- en cilindervervanging",
    desc: "Sleutel kwijt, na inbraak of upgrade? Wij vervangen sloten snel en veilig. SKG** en SKG*** keurmerk. Spoed 7/7.",
    price: "Vanaf €85",
    link: "/slot-cilinder-vervangen/",
    linkText: "Meer →",
  },
  {
    title: "Velux en dakraam",
    desc: "Lekkende Velux, vastgelopen mechanisme of motor stuk? Alle merken: Velux, Fakro, Roto Frank, Keylite. Op hoogte uitgerust.",
    price: "Vanaf €125",
    link: "/velux-reparatie/",
    linkText: "Meer →",
  },
  {
    title: "Inbraakschade reparatie",
    desc: "Inbraak gehad? Binnen 2 uur voor uw deur. Noodbeveiliging, herstel en schadedossier voor verzekering.",
    price: "Op offerte",
    link: "/inbraakschade-reparatie/",
    linkText: "Meer →",
    badge: "24/7",
  },
  {
    title: "Raamkruk vervangen",
    desc: "Versleten kruk? Alle merken, alle kleuren (wit, RAL, RVS, brons). Vaak binnen 30 min per kruk.",
    price: "Vanaf €85",
    link: "/raamkruk-vervangen/",
    linkText: "Meer →",
  },
  {
    title: "Slotenmaker 24/7",
    desc: "Buitengesloten, slot defect of na inbraak? Slotenmaker in Eindhoven 24/7. Vaste prijs, SKG-gecertificeerd.",
    price: "Vanaf €75",
    link: "/slotenmaker-eindhoven/",
    linkText: "Meer →",
    badge: "24/7",
  },
];